module.exports = new __parcel__URL__("nist-nec--dataset-cover.3029938a.jpg").toString();